import type { ResourcePresenceViewer } from '@/types/websocket'

export function excludeSelf(
	viewers: ResourcePresenceViewer[],
	userId: string | null | undefined
): ResourcePresenceViewer[] {
	if (!userId) {
		return viewers
	}
	return viewers.filter((viewer) => viewer.user_id !== userId)
}
